import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { InsuredAmountInput } from '../../../../fulfillment-planner/insured-amount';
import Global from '../../../../store/global-selectors';

import style from './package-insurance.module.css';
import { DisabledWithToolTip } from './disabled-with-tooltip';

const PackageInsuranceComponent = ({ insuredValue, onChange, hasInsuranceProviderSelected, labelId }) => {
  const sellerDefaultCurrency = useSelector(Global.selectSellerDefaultCurrency);
  const defaultInsurance = {
    code: sellerDefaultCurrency,
  };

  return (
    <div className={style['insurance-input']}>
      <InsuredAmountInput
        disabled={!hasInsuranceProviderSelected}
        insuredAmount={insuredValue || defaultInsurance}
        labelId={labelId}
        onChange={onChange}
      />
      {!hasInsuranceProviderSelected && <DisabledWithToolTip />}
    </div>
  );
};

PackageInsuranceComponent.propTypes = {
  insuredValue: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  hasInsuranceProviderSelected: PropTypes.bool.isRequired,
  labelId: PropTypes.string,
};

export const PackageInsurance = memo(PackageInsuranceComponent);
